// @ts-nocheck
import {Column} from 'react-table'
import {EmployeeInfoCell} from './PlanInfoCell'
import {EmployeeTwoStepsCell} from './PlanTwoStepsCell'
import {EmployeeActionsCell} from './PlanActionsCell'
import {EmployeeCustomHeader} from './PlanCustomHeader'
import {Employee} from '../../core/_models'

const EmployeeColumns: ReadonlyArray<Column<Employee>> = [
  {
    Header: (props) => (
      <EmployeeCustomHeader tableProps={props} title='S.No' className='min-w-125px' />
    ),
    accessor: 'serialNo',
  },
  {
    Header: (props) => (
      <EmployeeCustomHeader tableProps={props} title='Name' className='min-w-125px' />
    ),
    accessor: 'name',
  },
  {
    Header: (props) => (
      <EmployeeCustomHeader tableProps={props} title='Amount' className='min-w-125px' />
    ),
    accessor: 'amount',
  },
  {
    Header: (props) => (
      <EmployeeCustomHeader tableProps={props} title='Offer Price' className='min-w-125px' />
    ),
    accessor: 'offer_price',
  },
  {
    Header: (props) => (
      <EmployeeCustomHeader tableProps={props} title='Days' className='min-w-125px' />
    ),
    accessor: 'days',
  },
  {
    Header: (props) => (
      <EmployeeCustomHeader tableProps={props} title='Plan Category' className='min-w-125px' />
    ),
    accessor: 'planType.name',
  },
  {
    Header: (props) => (
      <EmployeeCustomHeader tableProps={props} title='Plan Type' className='min-w-125px' />
    ),
    accessor: 'user_type',
    Cell: ({...props}) => <EmployeeInfoCell Plan={props.data[props.row.index]} />,
  },

  {
    Header: (props) => (
      <EmployeeCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <EmployeeActionsCell Plan={props.data[props.row.index]} />,
  },
]

export {EmployeeColumns}
